import React, { useEffect, useState } from 'react'
import { Button, Calendar, Tag } from 'primereact';


import Card from '../../../../Base/Components/Card/Card';
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';



import { colorCotton, colorSintetico } from '../../../../Styles/Colors';
import { salidasHilaza } from '../../../../API/Produccion/BodegaHilaza/BodegaHilazaRequests';

import { getDateTimeStringSQL, getDatesProduccion  } from '../../../../Base/Services/Moment/Luxon';
import { ArchivosExcelService } from '../../../../Base/Services/ArchivosService';

export const SalidasHilazaScreen = () => {


    const [salidas, setSalidas] = useState([]);
    const [date, setDate] = useState([new Date(), new Date()]);
    const [loading, setLoading] = useState(false);

    const categoryTemplate = (rowData) => {
        switch (rowData.StyleCategory) {
            case 'Cotton':
                return <Tag severity='danger' className='col-12' value={rowData.StyleCategory} style={{ backgroundColor: colorCotton }} />
                break;
            case 'Synthetic':
                return <Tag severity='info' className='col-12' value={rowData.StyleCategory} style={{ backgroundColor: colorSintetico }} />
                break;
            case 'Spandex':
                return <Tag className='col-12' value={rowData.StyleCategory} style={{ backgroundColor: '#ffc605' }} />
                break;

            default:
                return <div>{rowData.StyleCategory}</div>
                break;
        }
    }


    const columns = [
        {
            header: 'Codigo Producto',
            field: 'CodigoProducto',
            frozen: true,
        },
        {
            header: 'Hilaza',
            field: 'Component',
            frozen: true,
        },
        {
            header: 'Categoria',
            field: 'StyleCategory',
            Format: 'Template',
            body: categoryTemplate,
            className: 'small'
        },
        {
            header: 'Fecha Salida',
            field: 'Fecha',
            Format: 'DateTime'
        },
        {
            header: 'Turno',
            field: 'Turno',
            className: 'Xsmall',
            Format: 'Center'
        },

        {
            header: 'Cliente',
            field: 'Customer',
        },
        {
            header: 'Reciclado',
            field: 'Reciclado',
            Format: 'Checkbox',
            className: 'Xsmall'
        },
        {
            header: 'Tela',
            field: 'StyleName',
            className: 'XXlarge',
            Sumary: 'count'
        },
        {
            header: 'Lote',
            field: 'LotName',
            className: 'small'
        },
        {
            header: 'Cajas',
            field: 'Cajas',
            className: 'Xsmall',
            Format: 'Decimal',
            Sumary: 'sum'
        },
        {
            header: 'Cantidad',
            field: 'Cantidad',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum'
        },
        {
            header: 'Price',
            field: 'Price',
            className: 'small',
            Format: 'Decimal'
        },
        {
            header: 'Monto',
            field: 'Monto',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum'
        },
        {
            header: 'DevKgs',
            field: 'DevKgs',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum'
        },
        {
            header: 'Factura',
            field: 'Factura',
        },
        {
            header: 'Orden Compras',
            field: 'PurchaseOrder',
            className: 'small'
        },
        {
            header: 'Orden Ingreso',
            field: 'OrdenIngreso',
            className: 'small'
        },
        {
            header: 'Requisa',
            field: 'IdRequisa',
            className: 'Xsmall'
        },
        {
            header: 'OrdenSalida',
            field: 'OrdenSalida',
            className: 'small'
        },
        {
            header: 'Orden Tejido',
            field: 'OrdenTejido',
        },
        {
            header: 'Orden Ventas',
            field: 'SalesOrder',
        },
        {
            header: 'Cliente Contrato',
            field: 'KCIdCustomer',
            className: 'Xlarge'
        },
        {
            header: 'Comprador Contrato',
            field: 'KCIdBuyer',
            className: 'small'
        },
        {
            header: 'Terminos',
            field: 'TermName',
            className: 'Xsmall'
        },
        {
            header: 'Tipo Ingreso',
            field: 'TipoIngreso',
            className: 'Xsmall'
        },
        {
            header: 'Comentario Destino',
            field: 'ComentarioDestino',
            className: 'large'
        },
        {
            header: 'MQ#',
            field: 'IdMachine',
            className: 'Xsmall'
        },
        {
            header: 'Tipo Salida',
            field: 'TipoSalidaN',
            className: 'medium'
        },
        {
            header: 'Tipo Uso',
            field: 'TipoUso',
            className: 'small'
        },
        {
            header: 'Proveedor',
            field: 'Vendor',
            className: 'Xlarge'
        },
        {
            header: 'Manufacturera',
            field: 'YarnManufacture',
            className: 'Xlarge'
        },
        {
            header: 'Camion',
            field: 'Camion',
            className: 'small'
        },
        {
            header: 'Lote Producción',
            field: 'Lotnumber2',
            className: 'large'
        },
        {
            header: 'Enviado por',
            field: 'AgentName',
        },
        {
            header: 'Planta Tejido',
            field: 'Contractor',
            className: 'small'
        },
        {
            header: 'SOTransferida',
            field: 'SOTransferida',
        },
        {
            header: 'KCTransferida',
            field: 'KCTransferida',
        },

    ];

    const table = {
        Columns: columns,
        Data: salidas,
        loading: loading
    }

    const getInfo = async () => {
        setLoading(true)
        const fechas = getDatesProduccion(date);
        const a = await salidasHilaza(fechas);
        console.log(a);
        setSalidas(a);
        setLoading(false)
    }


    const exportarExcel = () => {
        const t = salidas.map(i => {
            let data = {}
            columns.forEach(col => {
                data[col.header] = i[col.field]
            })
            return data;
        })
        ArchivosExcelService(t, 'Salidas Hilaza')
    }


    useEffect(() => {
        window.document.title = 'PPF • Ingresos Hilaza';
        getInfo()
    }, [])



    return (
        <div className='p-3'>
            <Card
                titulo={<div className='d-flex' style={{ alignItems: 'center' }}>
                    <h3>Salidas Hilaza</h3>
                    <span className='mx-3'>Rango Fechas:</span>
                    <Calendar
                        id="monthpicker"
                        value={date}
                        onChange={(e) => setDate(e.value)}
                        selectionMode='range'
                        dateFormat="dd/mm/yy"
                        showIcon
                        className='mx-1'
                        showButtonBar={true}
                    />
                    <Button className='mx-1' icon={'pi pi-search'} onClick={e => getInfo()} />
                    <Button icon={'pi pi-file-excel'} className='p-button-success mx-1' onClick={e => { exportarExcel() }} />
                </div>}
                contenido={<div className='pt-4' style={{ height: '88vh' }}>
                    <AgGrid table={table} />
                </div>}
            />
        </div>
    )
}

export default SalidasHilazaScreen